/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RewardTypes } from './reward-types';


export interface PoolMiningCommissionItem { 
    currencyId: number;
    currencyTicker: string;
    rewardType: RewardTypes;
    commission: number;
}



